import { useQuery } from '@tanstack/react-query';
import { activitiesService } from '../services/activitiesService';

/**
 * Hook to fetch user's pending activities (for header dropdown)
 * Returns activities the user needs to complete today or overdue
 */
export const useMyActivities = (limit: number = 10) => {
  return useQuery({
    queryKey: ['my-activities', limit],
    queryFn: () => activitiesService.getMyActivities(limit),
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchInterval: 60 * 1000, // Auto-refresh every 1 minute
  });
};
